import { fetcher } from "../../../utils/Axios";
import { useQuery } from "@tanstack/react-query";
import { GET_ANESTHESIA_START_INTERVAL_QUERY_KEY } from "../types/CommonTypes";
import { GET_ANESTHESIA_START_INTERVAL_RESPONSE } from "../types/ResponseTypes";

async function getAnesthesiaStartInterval(
  tenantId?: string,
  hospitalId?: string,
  queryString?: string
): Promise<GET_ANESTHESIA_START_INTERVAL_RESPONSE> {
  const baseUrl = "analytics/in-room-anesthesia-start-interval";
  const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

  const { data } = await fetcher({
    url,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

export default function useGetAnesthesiaStartIntervalQuery(
  tenantId?: string,
  hospitalId?: string,
  queryString: string = ""
) {
  return useQuery({
    queryKey: [
      GET_ANESTHESIA_START_INTERVAL_QUERY_KEY,
      queryString,
      hospitalId,
    ],
    queryFn: () =>
      getAnesthesiaStartInterval(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
    enabled: !!tenantId && !!hospitalId,
  });
}
